const RequiredValidator = (errorMessage) => {
    return async (value) => {
        if (value === undefined || value === null || value === '' || (value instanceof Array && value.length === 0)) {
            return {
                valid: false,
                error: errorMessage,
            };
        }

        // disallow strings made out of whitespaces
        if (typeof value === 'string' && value.trim() === '') {
            return {
                valid: false,
                error: errorMessage,
            };
        }

        return { valid: true };
    };
};

const GzServerAddressValidator = (errorMessage) => {
    return async (value) => {
        let gzServerAddress = RegExp(
            "((https)://)cloud(.*).gravityzone.bitdefender.com/api" + "$", 'i'
        ).test(value)
            ? ""
            : "invalid serverAddress";

        if (gzServerAddress === '') {
            return { valid: true };
        }

        return {
            valid: false,
            error: errorMessage,
        };
    };
};

const AlphaNumericValidator = (errorMessage) => {
    return async (value) => {
        var code, i, len;

        for (i = 0, len = value.length; i < len; i++) {
            code = value.charCodeAt(i);
            if (!(code > 47 && code < 58) && // numeric (0-9)
                !(code > 64 && code < 91) && // upper alpha (A-Z)
                !(code > 96 && code < 123)) { // lower alpha (a-z)
                return {
                    valid: false,
                    error: errorMessage
                };
            }
        }
        return { valid: true };
    };
};

const MaxLengthValidator = (maxLength, errorMessage) => {
    return async (value) => {
        if (value === undefined || value === null) {
            return { valid: true };
        }

        if (value.length > maxLength) {
            return {
                valid: false,
                error: errorMessage,
            };
        }

        return { valid: true };
    };
};

const ExactLengthValidator = (exactLength, errorMessage) => {
    return async (value) => {
        if (value === undefined || value === null) {
            return { valid: true };
        }

        if (value.length !== parseInt(exactLength)) {
            return {
                valid: false,
                error: errorMessage,
            };
        }

        return { valid: true };
    };
};

const UrlValidator = (errorMessage) => {
    return async (value) => {
        if (value === undefined || value === null) {
            return { valid: true };
        }

        let url;

        try {
            url = new URL(value);
        } catch (_) {
            return {
                valid: false,
                error: errorMessage,
            };
        }

        return { valid: url.protocol === 'https:' };
    };
}

export {
    RequiredValidator,
    MaxLengthValidator,
    GzServerAddressValidator,
    AlphaNumericValidator,
    ExactLengthValidator,
    UrlValidator
}